import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHomepageSections } from "../../../store/adminDataStore";

export default function HeroSection() {
  const { i18n } = useTranslation();
  const lang = (i18n.language?.split("-")[0] ?? "en") as "zh" | "en" | "ja";
  const heroSections = useHomepageSections("hero");

  // sort_order=1 → main headline + subheadline + background image
  const mainHero = heroSections.find((h) => h.sort_order === 1);
  // sort_order=2 → second headline line + CTA button text
  const taglineHero = heroSections.find((h) => h.sort_order === 2);

  const headline1 = mainHero?.[`title_${lang}`] || mainHero?.title_en || "Capture Your Journey";
  const headline2 = taglineHero?.[`title_${lang}`] || taglineHero?.title_en || "in Japan";
  const subheadline = mainHero?.[`content_${lang}`] || mainHero?.content_en || "";
  const ctaText = taglineHero?.[`content_${lang}`] || taglineHero?.content_en || "Begin Your Story";
  const bgImage = mainHero?.image_url || "";

  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={bgImage}
          alt="TaBiFoTo hero — photography in Japan"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/25 to-black/60" />
        <div className="absolute inset-0 bg-[#2C2C2C]/10 mix-blend-multiply" />
      </div>

      <div className="relative z-10 text-center w-full px-6 flex flex-col items-center">
        <p className="text-xs uppercase tracking-[0.4em] text-white/50 mb-6 font-light">TaBiFoTo</p>
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-extralight text-white leading-tight mb-4" style={{ letterSpacing: "-0.02em" }}>
          {headline1}
        </h1>
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-extralight text-white leading-tight mb-8" style={{ letterSpacing: "-0.02em" }}>
          {headline2}
        </h2>
        <p className="text-base md:text-lg text-white/60 font-light max-w-lg leading-relaxed mb-12">
          {subheadline}
        </p>
        <Link
          to="/booking"
          className="inline-flex items-center gap-3 px-10 py-4 rounded-full bg-white/10 backdrop-blur-sm border border-white/30 text-white text-sm tracking-widest uppercase hover:bg-white/20 hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          {ctaText}
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line" />
          </div>
        </Link>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-px h-10 bg-white/30" />
        <div className="w-3 h-3 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/30 text-xs" />
        </div>
      </div>
    </section>
  );
}
